var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66666667,0 C0.7475,0 0,0.748333333 0,1.66666667 L0,16.6666667 C0,17.5858333 0.7475,18.3333333 1.66666667,18.3333333 L13.3333333,18.3333333 C14.2525,18.3333333 15,17.5858333 15,16.6666667 L15,3.82166667 L11.1783333,0 L1.66666667,0 Z M7.5,12.5 L2.5,12.5 L2.5,10.8333333 L7.5,10.8333333 L7.5,12.5 Z M10,9.16666667 L2.5,9.16666667 L2.5,7.5 L10,7.5 L10,9.16666667 Z M10,5 L10,0.833333333 L14.1666667,5 L10,5 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.f91b38813e28338ed8f1f503e6fd8715.svg";
export { ForwardRef as ReactComponent };